export enum EmspUserServiceStatusEnum {
  ACTIVE = 'ACTIVE',
  UNPAID = 'UNPAID',
  PENDING = 'PENDING',
  SUSPENDED = 'SUSPENDED',
  INACTIVE = 'INACTIVE'
}
